import Warning from '@mui/icons-material/Warning'
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material'
import { RetailerAccount } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import { useSelector } from 'react-redux'

import campaignContentPaths from '@src/components/content/campaignContentPaths'
import LinkChild from '@src/lib/LinkChild'
import { formatWithoutCents } from '@src/lib/Utils'
import { currentRetailerAccountSelector } from '@src/stores/app/selectors'

import { PAID_AD_ENDING_THRESHOLD, RandomAdFromRedux } from './constants'

const WalletPaidAds: React.FC<
  React.PropsWithChildren<{ paidAds: RandomAdFromRedux[] }>
> = (props) => {
  const currentRetailerAccount: RetailerAccount = useSelector(
    currentRetailerAccountSelector,
  )

  const endingSoon = (
    <>
      <Warning
        color="inherit"
        fontSize="small"
        sx={{ verticalAlign: 'bottom' }}
      />{' '}
      {I18n.t('wallet.campaignFunds.endingSoon')}
    </>
  )

  return (
    <>
      {props.paidAds.length === 0 ? (
        <Typography color="text.secondary" textAlign="center" padding={4}>
          {I18n.t('wallet.campaignFunds.noneAvailable')}
        </Typography>
      ) : undefined}

      <List dense disablePadding>
        {props.paidAds.map((ad, index, list) => {
          return (
            <LinkChild
              to={campaignContentPaths.activatePaidCampaign.build({
                retailerAccountSlug: currentRetailerAccount.slug || '',
                activeTab: 'paid',
                campaignId: ad.id,
              })}
            >
              <ListItem
                disableGutters
                divider={index < list.length - 1}
                key={ad.id}
                button
                component="a"
              >
                <ListItemAvatar>
                  <Avatar
                    src={ad.brandLogo}
                    variant="square"
                    sx={{ '> img': { objectFit: 'contain' } }}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={ad.title}
                  secondary={
                    isPaidAdEndingSoon(new Date(ad.starts_at))
                      ? endingSoon
                      : undefined
                  }
                  secondaryTypographyProps={{
                    color: 'error.main',
                  }}
                />
                <Typography color="text.secondary" variant="body2">
                  {formatWithoutCents.format(ad.creditAmount / 100)}
                </Typography>
              </ListItem>
            </LinkChild>
          )
        })}
      </List>
    </>
  )
}

function isPaidAdEndingSoon(date: Date) {
  return date.valueOf() - new Date().valueOf() <= PAID_AD_ENDING_THRESHOLD
}

export default WalletPaidAds
